import product1 from "./media/product1.png";
import product2 from "./media/product2.png";
import product3 from "./media/product3.png";
import product4 from "./media/product4.jpg";
import product5 from "./media/product5.jpg";
import product6 from "./media/product6.jpg";

const AllProducts = [
  {
    id: 0,
    productName: "Choco Truffle",
    sellingPrice: 799,
    image: product1,
  },
  {
    id: 1,
    productName: "Black Forest",
    sellingPrice: 749,
    image: product2,
  },
  {
    id: 2,
    productName: "Black Forest",
    sellingPrice: 749,
    image: product3,
  },
  // {
  //   id: 3,
  //   productName: "Choco Truffle",
  //   sellingPrice: 799,
  //   image: product4,
  // },
  // {
  //   id: 4,
  //   productName: "Choco Truffle",
  //   sellingPrice: 799,
  //   image: product5,
  // },
  // {
  //   id: 5,
  //   productName: "Choco Truffle",
  //   sellingPrice: 799,
  //   image: product6,
  // },
];

const flavors = [
  {
    id: 0,
    name: "Vanilla",
    pricePerKg: 650,
    isAvailable: true,
  },
  {
    id: 1,
    name: "Butterscotch",
    pricePerKg: 650,
    isAvailable: true,
  },
  {
    id: 2,
    name: "Chocolate",
    pricePerKg: 700,
    isAvailable: true,
  },
  {
    id: 3,
    name: "Blueberry",
    pricePerKg: 799,
    isAvailable: true,
  },
  {
    id: 4,
    name: "Pistachio",
    pricePerKg: 799,
    isAvailable: true,
  },
];

const toppings = [
  {
    id: 0,
    name: "Dusted cocoa",
    price: 40,
  },
  {
    id: 1,
    name: "Shredded  coconut",
    price: 20,
  },
  {
    id: 2,
    name: "Chopped  nuts",
    price: 20,
  },
  {
    id: 3,
    name: "Cookie springle",
    price: 30,
  },
  {
    id: 4,
    name: "Oreo",
    price: 20,
  },
  {
    id: 5,
    name: "Kitkat",
    price: 35,
  },
];

const edibleAccessories = [
  {
    id: 0,
    name: "Crown",
    price: 80,
  },
  {
    id: 1,
    name: "Cartoon faces",
    price: 85,
  },
  {
    id: 2,
    name: "Sports props",
    price: 120,
  },
  {
    id: 3,
    name: "Miniatures",
    price: 199,
  },
];

const cart = [
  {
    id: 0,
    productName: "Choco Truffle",
    sellingPrice: 799,
    image: product1,
    quantity: 1,
  },
  {
    id: 1,
    productName: "Black Forest",
    sellingPrice: 749,
    image: product2,
    quantity: 2,
  },
  {
    id: 2,
    productName: "Black Forest",
    sellingPrice: 749,
    image: product3,
    quantity: 1,
  },
];

const reviews = [
  {
    id: 0,
    name: "Helen",
    review: "Loved all your cakes, seems soo authentic",
    rating: 5,
  },
  {
    id: 1,
    name: "Bablo",
    review:
      "Affordable and they are so comfortable that you can get whats on your mind 😍",
    rating: 4,
  },
  {
    id: 2,
    name: "Nila",
    review:
      "I got one for my mom, she keeps asking me the same for every others birthday 😍❤️",
    rating: 5,
  },
  {
    id: 3,
    name: "Viki",
    review: "Best of quality and quantity🍻",
    rating: 4,
  },
];

const singleProduct = {
  name: "Choco Truffle",
  pricePerKg: 799,
  images: [product1, product2, product3, product4, product5, product6],
};

const Data = {
  AllProducts,
  singleProduct,
  cart,
  reviews,
  flavors,
  toppings,
  edibleAccessories,
};

export default Data;
